module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.getters.audio) ? _c('v-layout', {
    staticClass: "align-center"
  }, [_c('v-flex', {
    staticClass: "mr-3",
    attrs: {
      "shrink": ""
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.$store.getters.audio.imgSource,
      "alt": "",
      "width": "72",
      "height": "72"
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-0"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'Track',
        params: {
          id: _vm.audio.id
        }
      }
    }
  }, [_c('v-flex', {
    staticClass: "pa-0 truncate semi-bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.$store.getters.audio.name))])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 truncate"
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$store.getters.audio.artist))])])], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "height": "55px"
    },
    attrs: {
      "shrink": ""
    }
  }, [_c('button-like-audio', {
    key: _vm.audio.id,
    attrs: {
      "audio": _vm.audio
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "secondary"
    }
  }, [_vm._v("favorite")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eadd6f9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThePlayer/ThePlayerAudioInfo.vue
// module id = 389
// module chunks = 0